<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import RawData from "@/components/widgets/raw-data.vue";
import { groupBy } from "lodash";

export default {
    name: 'AccomplishmentReport',
    page: {
        title: "Accomplishment Report",
    },
    components: {
        Layout,
        PageHeader,
        AttachmentModal,
        RawData
    },
    data() {
        return {
            title: "Accomplishment Report",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Accomplishment Report",
                    active: true,
                },
            ],
            loading: false,
            dus: [],
            searchDU: "",
            perPage: 10,
            currentPage: 1,
            pageOptions: [10, 25, 50, 100],
            kpis: [],
            filterByCampus: 'all',
            filterByCluster: 'all',
        };
    },
    methods: {
        async getKPIInDashboard() {
            try{
                const { data: response } = await this.$store.dispatch("indicatoritem/ShowKPIInAdminDashboard");
                if(response.error) {
                    return this.showToast(response.errorMessage, "error");
                }
                response.map(item => {
                    item.dusByCampus = [];
                    item.dusByCluster = [];
                    item.showDUs = false;
                    item.dusLoading = false;
                    item.filter = "";
                    item.filterBy = 1;
                    item.filterByCampus = 'all';
                    item.filterByCluster = 'all';
                })
                this.kpis = response;
            }catch(err) {
                this.showToast(
                    "Something went wrong! - getting delivery units",
                    "error"
                );
            }
        },
        async changeCycle(){
            this.kpis.map(item => {
                item.dusByCampus = [];
                item.dusByCluster = [];
                item.showDUs = false;
                item.dusLoading = false;
                item.filter = "";
                item.filterBy = 1;
            })
            if(this.kpis.length) {
                let kpi = this.kpis[0];
                kpi.showDUs = true;
                kpi.dusLoading = true;
                await this.getDUs(kpi);
                kpi.dusLoading = false;
            }
        },
        async getDUs(kpi) {
            try{
                const { data: response } = await this.$store.dispatch("indicatoritem/GetDUsByIndicatorItem", {
                    id: kpi.id,
                    cycle: this.$store.state.data.cycle,
                });
                if(response.error) {
                    return this.showToast(response.errorMessage, "error");
                }
                response.map(item => {
                    item.showFiles = false;
                    item.cluster = item.cluster ? item.cluster : "No Cluster";
                    item.kpiId = kpi.id;
                    item.actual = [];
                    item.movs = [];
                    item.filter = "";
                    item.filterKey = `${item.name}`;
                    item.fileLoading = false;
                    item.quarters = [
                        {id: 1, files: []},
                        {id: 2, files: []},
                        {id: 3, files: []},
                        {id: 4, files: []},
                    ];
                })
                kpi.dusByCampus = JSON.parse(JSON.stringify(response.sort((a, b) => a.campus.localeCompare(b.campus))));
                kpi.dusByCluster = JSON.parse(JSON.stringify(response.sort((a, b) => a.cluster.localeCompare(b.cluster))));
            }catch(err) {
                this.showToast(
                    "Something went wrong! - getting delivery units",
                    "error"
                );
            }
        },
        async getDocuments(du, quarter) {
            quarter.files = [];
            let actual = du.actual[0];
            let isPosted = actual[`q${quarter.id}Status`]?.toLowerCase().includes('posted') || actual[`q${quarter.id}Status`]?.toLowerCase().includes('approved');
            if(!isPosted) return;
            for await(const mov of du.movs) {
                try{
                    const { data: response } = await this.$store.dispatch("filemanager/GetFiles", {
                        id: actual.targetId,
                        type: `Quarter ${quarter.id} Files: ${mov.mode}`,
                        removeLoading: true,
                    });
                    if(response.error) {
                        continue;
                    }
                    quarter.files = quarter.files.concat(response);
                }catch(err) {
                    continue;
                }
                try{
                    const { data: response } = await this.$store.dispatch("filemanager/GetFiles", {
                        id: actual.targetId,
                        type: `Quarter ${quarter.id} Files: ${mov.id}`,
                        removeLoading: true,
                    });
                    if(response.error) {
                        continue;
                    }
                    quarter.files = quarter.files.concat(response);
                }catch(err) {
                    continue;
                }
            }
        },
        async getTargets(du){
            try{
                const { data: response } = await this.$store.dispatch("api/GetApisByIndicatorItem", {
                    deliveryUnitId: du.id,
                    indicatorItemId: du.kpiId,
                    cycle: this.$store.state.data.cycle,
                });
                if(response.error) {
                    return this.showToast(response.errorMessage, "error");
                }
                du.actual = response;
            }catch(err) {
                this.showToast(
                    "Something went wrong! - getting targets",
                    "error"
                );
            }
        },
        async getMOVs(du){
            let targetData = du.actual[0];
            try{
                const { data: response } = await this.$store.dispatch("mov/GetMOVByTarget", targetData.targetId);
                if(response.error) {
                    return this.showToast(response.errorMessage, "error");
                }
                du.movs = response;
                du.movs.push({
                    id: `others-${targetData.targetId}`,
                    mode: "OTHERS",
                });
                du.movs.push({
                    id: `catchup-${targetData.targetId}`,
                    mode: "CATCHUP PLANS",
                });
            }catch(err) {
                this.showToast(
                    "Something went wrong! - getting MOVs",
                    "error"
                );
            }
        },
        async toggleAccordion(kpi) {
            kpi.showDUs = !kpi.showDUs;
            if(kpi.showDUs && !kpi.dusByCampus.length && !kpi.dusByCluster.length) {
                kpi.dusLoading = true;
                await this.getDUs(kpi);
                kpi.dusLoading = false;
            }
        },
        async getFiles(du, quarter) {
            du.fileLoading = true;
            if(quarter.files.length == 0){
                await this.getDocuments(du, quarter);
            }
            du.fileLoading = false;
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        filteredFiles(search, files) {
            if(search) {
                return files.filter((item) => {
                    return item.description.toLowerCase().includes(search.toLowerCase());
                });
            }
            return files;
        },
        async downloadFile(id) {
            try{
                let res = await axios.get(`api/FileManager/ReadFile/${id}`, {withCredentials: true, responseType: 'blob'})
                let contentType = res.headers["content-type"];
                if (contentType.includes("json")) {
                return false;
                }
                let cd = res.headers["content-disposition"];
                let cdArr = cd.split(";");
                let filename = cdArr[1].trim().replace('filename=', '');
                var url = URL.createObjectURL(res.data);
                var link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (err) {
                this.showToast("Something went wrong! - downloading file","error");
            }
        },
        async showTemplates(du){
            this.$refs.attachmentModal.setUploadOpt({
                type: "Accomplishment Report Template",
                placement: "left",
                folder: "Planning",
            });
            this.$bvModal.show("upload-attachment-modal");
            await this.$refs.attachmentModal.getData(du.id);
        },
        async viewFiles(du) {
            du.showFiles = !du.showFiles;
            if(du.showFiles && du.quarters[0].files.length === 0) {
                du.fileLoading = true;
                if(du.actual.length == 0){
                    await this.getTargets(du);
                }
                if(du.movs.length == 0 && du.actual.length > 0){
                    await this.getMOVs(du);
                }
                if(du.actual.length > 0 && du.movs.length > 0){
                    await this.getDocuments(du, du.quarters[0]);
                }
                du.fileLoading = false;
            }
        },
        showCampuses(kpi){
            let campuses = [];
            let grp = groupBy(kpi.dusByCampus, "campus");
            for(const key in grp) {
                campuses.push({
                    name: key,
                })
            }
            return campuses;
        },
        showClusters(kpi){
            let clusters = [];
            let grp = groupBy(kpi.dusByCluster, "cluster");
            for(const key in grp) {
                clusters.push({
                    name: key,
                })
            }
            return clusters;
        },
        filteredDUsByCampus(kpi) {
            let data = kpi.dusByCampus;
            if(kpi.filter) {
                data = data.filter((item) => {
                    return item.filterKey.toLowerCase().includes(kpi.filter.toLowerCase());
                });
            }
            if(kpi.filterByCampus !== 'all') {
                data = data.filter((item) => {
                    return item.campus == kpi.filterByCampus;
                });
            }
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            let currentData = data.slice(start, end);
            let grp = groupBy(currentData, "campus");
            return Object.keys(grp).map(key => {
                return {
                    name: key,
                    dus: grp[key],
                }
            });
        },
        filteredDUsByCluster(kpi) {
            let data = kpi.dusByCluster;
            if(kpi.filter) {
                data = data.filter((item) => {
                    return item.filterKey.toLowerCase().includes(kpi.filter.toLowerCase());
                });
            }
            if(kpi.filterByCluster !== 'all') {
                data = data.filter((item) => {
                    return item.cluster === kpi.filterByCluster;
                });
            }
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            let currentData = data.slice(start, end);
            let grp = groupBy(currentData, "cluster");
            return Object.keys(grp).map(key => {
                let dus = grp[key];
                let grpDus = groupBy(dus, "campus");
                return {
                    name: key,
                    campuses: Object.keys(grpDus).map(campus => {
                        return {
                            name: campus,
                            dus: grpDus[campus],
                        }
                    }),
                }
            });
        },
        rows(kpi) {
            let data = kpi.filterBy == 1 ? kpi.dusByCampus : kpi.dusByCluster;
            if(kpi.filter) {
                data = data.filter((item) => {
                    return item.name.toLowerCase().includes(kpi.filter.toLowerCase());
                });
            }
            if(kpi.filterBy == 1 && kpi.filterByCampus !== 'all') {
                data = data.filter((item) => {
                    return item.campus == kpi.filterByCampus;
                });
            }
            if(kpi.filterBy == 2 && kpi.filterByCluster !== 'all') {
                data = data.filter((item) => {
                    return item.cluster === kpi.filterByCluster;
                });
            }
            return data.length;
        },
        changeFilter(kpi, filterBy) {
            kpi.filterBy = filterBy;
            this.currentPage = 1;
        },
        changeCampusFilter(kpi, campus) {
            kpi.filterByCampus = campus;
            this.currentPage = 1;
        },
        changeClusterFilter(kpi, cluster) {
            kpi.filterByCluster = cluster;
            this.currentPage = 1;
        },
    },
    async created() {
        this.loading = true;
        await this.getKPIInDashboard();
        this.loading = false;
        if(this.kpis.length) {
            let kpi = this.kpis[0];
            kpi.showDUs = true;
            kpi.dusLoading = true;
            await this.getDUs(kpi);
            kpi.dusLoading = false;
        }
    },
}
</script>
<template>
    <Layout @changeCycle="changeCycle">
        <PageHeader :title="title" :items="items" />
        <template v-for="x in kpis" >
            <b-card no-body class="mb-2" :key="x.id">
                <b-card-header
                    header-tag="header"
                    role="tab"
                    class="d-flex align-items-center justify-content-between cursor-pointer"
                    @click="toggleAccordion(x)"
                >   
                    <div>
                        <h4 class="mb-0">View {{ x.indicatorItemName }} <b>{{ $store.state.data.cycle }}</b></h4>
                        <small>Click the delivery unit to view the accomplishment reports by quarter.</small>
                    </div>
                    <div class="d-flex gap-1" v-if="x.showDUs">
                        <input 
                            type="text" 
                            class="form-control w-auto" 
                            placeholder="Search Delivery Unit..." 
                            v-model="x.filter" 
                            @click.stop
                            @input="currentPage = 1"
                        >
                        <select class="form-select" @click.stop v-model="perPage">
                            <option v-for="x in pageOptions" :key="x" :value="x">{{ x }}</option>
                        </select>
                    </div>
                </b-card-header>
                <b-collapse
                    :accordion="`accordion-du-${x.id}`"
                    role="tabpanel"
                    :visible="x.showDUs"
                >
                    <b-card-body class="border-top">
                        <template v-if="x.dusLoading">
                            <div class="d-flex align-items-center justify-content-center py-5">
                                <b-spinner variant="primary" label="Loading..."></b-spinner>
                            </div>
                        </template>
                        <template v-else>
                            <template v-if="(x.filterBy == 1 && x.dusByCampus.length == 0) || (x.filterBy == 2 && x.dusByCluster.length == 0)">
                                <div class="d-flex align-items-center justify-content-center py-5">
                                    <div class="text-center">
                                        <i class="bx bx-building font-size-24 mb-2"></i>
                                        <p class="mb-0">No delivery units found.</p>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex gap-1 mb-3">
                                        <div class="border py-2 px-5 pill br-5 cursor-pointer" :class="{'bg-blue': x.filterBy == 1}" @click="changeFilter(x, 1)">
                                            By Campus
                                        </div>
                                        <div class="border py-2 px-5 pill br-5 cursor-pointer" :class="{'bg-blue': x.filterBy == 2}" @click="changeFilter(x, 2)">
                                            By Cluster
                                        </div>
                                    </div>
                                    <div>
                                        <b-dropdown
                                            menu-class="dropdown-menu-end"
                                            variant="black"
                                            toggle-class="p-0"
                                            v-if="x.filterBy == 1"
                                        >
                                            <template v-slot:button-content>
                                                <button class="btn btn-secondary w-100px ">
                                                    <i class="bx bx-slider"></i> Filters
                                                </button>
                                            </template>
                                            <b-dropdown-item @click="changeCampusFilter(x, 'all')">
                                                <div class="d-flex">
                                                    <div style="width: 20px">
                                                        <i class="bx bx-check" v-if="x.filterByCampus === 'all'"></i>
                                                    </div>
                                                    All
                                                </div>
                                            </b-dropdown-item>
                                            <b-dropdown-item
                                                v-for="campus in showCampuses(x)"
                                                :key="campus.name"
                                                @click="changeCampusFilter(x, campus.name)"
                                            >
                                                <div class="d-flex">
                                                    <div style="width: 20px">
                                                        <i class="bx bx-check" v-if="x.filterByCampus === campus.name"></i>
                                                    </div>
                                                    {{ campus.name }}
                                                </div>
                                            </b-dropdown-item>
                                        </b-dropdown>
                                        <b-dropdown
                                            menu-class="dropdown-menu-end"
                                            variant="black"
                                            toggle-class="p-0"
                                            v-if="x.filterBy == 2"
                                        >
                                            <template v-slot:button-content>
                                                <button class="btn btn-secondary w-100px ">
                                                    <i class="bx bx-slider"></i> Filters
                                                </button>
                                            </template>
                                            <b-dropdown-item @click="changeClusterFilter(x, 'all')">
                                                <div class="d-flex">
                                                    <div style="width: 20px">
                                                        <i class="bx bx-check" v-if="x.filterByCluster === 'all'"></i>
                                                    </div>
                                                    All
                                                </div>
                                            </b-dropdown-item>
                                            <b-dropdown-item
                                                v-for="cluster in showClusters(x)"
                                                :key="cluster.name"
                                                @click="changeClusterFilter(x, cluster.name)"
                                            >
                                                <div class="d-flex">
                                                    <div style="width: 20px">
                                                        <i class="bx bx-check" v-if="x.filterByCluster === cluster.name"></i>
                                                    </div>
                                                    {{ cluster.name }}
                                                </div>
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                </div>
                                <template v-if="x.filterBy == 1">
                                    <template v-for="(du, ind) in filteredDUsByCampus(x)">
                                        <ul :key="ind">
                                            <li class="mb-3">
                                                <h5 class="mb-0 cursor-pointer text-white">{{ du.name }}</h5>
                                            </li>
                                            <b-card no-body 
                                                v-for="y in du.dus"
                                                class="mb-2 shadow-none border"
                                                :key="y.id"
                                            >
                                                <RawData :data="y" v-if="$store.state.decrypt.isAdmin()"/>
                                                <b-card-header
                                                    header-tag="header"
                                                    role="tab"
                                                    class="rounded cursor-pointer position-relative py-3"
                                                    @click="viewFiles(y)"
                                                > 
                                                    <h5 class="mb-0">{{ y.name }}</h5>
                                                </b-card-header>
                                                <b-collapse
                                                    :accordion="`accordion-du-${y.id}`"
                                                    role="tabpanel"
                                                    :visible="y.showFiles"
                                                >
                                                    <b-card-body class="border-top">
                                                        <b-tabs
                                                            pills
                                                            vertical
                                                            nav-class="p-0"
                                                            nav-wrapper-class="col-sm-2 border-end"
                                                            content-class="text-muted"
                                                        >
                                                            <b-tab title-item-class="mb-2" v-for="q in y.quarters" :key="q.id" @click="getFiles(y, q)">
                                                                <template v-slot:title>
                                                                    <span class="d-none d-sm-inline-block">
                                                                        Quarter {{ q.id }}
                                                                    </span>
                                                                </template>
                                                                <div v-if="x.fileLoading">
                                                                    <div class="d-flex align-items-center justify-content-center py-5">
                                                                        <b-spinner variant="primary" label="Loading..."></b-spinner>
                                                                    </div>
                                                                </div>
                                                                <template v-else>
                                                                    <template v-if="q.files.length == 0">
                                                                        <div class="d-flex align-items-center justify-content-center py-5">
                                                                            <div class="text-center">
                                                                                <i class="bx bx-file font-size-24 mb-2"></i>
                                                                                <p class="mb-0">No files submitted for this quarter.</p>
                                                                            </div>
                                                                        </div>
                                                                    </template>
                                                                    <template v-else>
                                                                        <div class="mb-2">
                                                                            <input type="text" class="form-control w-auto" placeholder="Search files..." v-model="y.filter">
                                                                        </div>
                                                                        <template v-if="filteredFiles(y.filter, q.files).length === 0">
                                                                            <div class="d-flex align-items-center justify-content-center py-5">
                                                                                <div class="text-center">
                                                                                    <i class="bx bx-file font-size-24 mb-2"></i>
                                                                                    <p class="mb-0">No files match your search.</p>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                        <template v-else>
                                                                            <div class="d-flex flex-wrap gap-2">
                                                                                <div
                                                                                    v-for="(y, index) in filteredFiles(y.filter, q.files)"
                                                                                    :key="y.id"
                                                                                    class="position-relative cursor-pointer border br-5"
                                                                                    :style="`width: 300px; z-index: ${q.files.length - index}`"
                                                                                >
                                                                                    <div class="border p-3 h-100 d-flex flex-column">
                                                                                        <div>
                                                                                            <div class="float-end ms-2">
                                                                                                <b-dropdown
                                                                                                    right
                                                                                                    variant="link"
                                                                                                    toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                                                    menu-class="dropdown-menu-end"
                                                                                                    no-caret
                                                                                                >
                                                                                                    <template #button-content>
                                                                                                        <i class="mdi mdi-dots-horizontal"></i>
                                                                                                    </template>
                                                                                                    <b-dropdown-item @click="openDocument(y)">
                                                                                                        <i class="bx bx-link-external me-1"></i>Open
                                                                                                    </b-dropdown-item>
                                                                                                    <b-dropdown-item  @click="downloadFile(y.id)">
                                                                                                        <i class="bx bx-download me-1"></i>Download
                                                                                                    </b-dropdown-item>
                                                                                                </b-dropdown>
                                                                                            </div>
                                                                                            <div class="avatar-xs me-3 mb-2" @click="openDocument(y)">
                                                                                                <div class="avatar-title bg-transparent rounded">
                                                                                                    <i
                                                                                                        v-if="y.fileType && y.fileType.includes('image')"
                                                                                                        class="mdi mdi-image font-size-24 text-purple"
                                                                                                    ></i>
                                                                                                    <i
                                                                                                        v-if="y.fileType && y.fileType.includes('application')"
                                                                                                        class="mdi mdi-file-pdf-outline font-size-24 text-danger"
                                                                                                    ></i>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="d-flex" @click="openDocument(y)">
                                                                                                <div class="overflow-hidden me-auto">
                                                                                                    <h5 class="font-size-14 text-truncate mb-1 hover-underline">{{ y.description }}</h5>
                                                                                                    <p class="text-muted mb-0">
                                                                                                        {{ formatDateWithTime(new Date(y.dateTimeUploaded)) }}
                                                                                                    </p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                    </template>
                                                                </template>
                                                            </b-tab>
                                                        </b-tabs>
                                                    </b-card-body>
                                                </b-collapse>
                                            </b-card>
                                        </ul>
                                    </template>
                                </template>
                                <template v-if="x.filterBy == 2">
                                    <template v-for="(a, aInd) in filteredDUsByCluster(x)">
                                        <ul :key="aInd">
                                            <li>
                                                <h4 class="mb-0 cursor-pointer text-white">{{ a.name }}</h4>
                                                <ul v-for="(z, zInd) in a.campuses" :key="zInd" class="px-3">
                                                    <li>
                                                        <h5 class="mb-0 cursor-pointer mt-3 mb-2 text-orange">{{ z.name }}</h5>
                                                        <b-card no-body 
                                                            v-for="y in z.dus"
                                                            class="mb-2 shadow-none border"
                                                            :key="y.id"
                                                        >
                                                            <RawData :data="y" v-if="$store.state.decrypt.isAdmin()"/>
                                                            <b-card-header
                                                                header-tag="header"
                                                                role="tab"
                                                                class="rounded cursor-pointer position-relative py-3"
                                                                @click="viewFiles(y)"
                                                            > 
                                                                <h5 class="mb-0">{{ y.name }}</h5>
                                                            </b-card-header>
                                                            <b-collapse
                                                                :accordion="`accordion-du-${y.id}`"
                                                                role="tabpanel"
                                                                :visible="y.showFiles"
                                                            >
                                                                <b-card-body class="border-top">
                                                                    <b-tabs
                                                                        pills
                                                                        vertical
                                                                        nav-class="p-0"
                                                                        nav-wrapper-class="col-sm-2 border-end"
                                                                        content-class="text-muted"
                                                                    >
                                                                        <b-tab title-item-class="mb-2" v-for="q in y.quarters" :key="q.id" @click="getFiles(y, q)">
                                                                            <template v-slot:title>
                                                                                <span class="d-none d-sm-inline-block">
                                                                                    Quarter {{ q.id }}
                                                                                </span>
                                                                            </template>
                                                                            <div v-if="x.fileLoading">
                                                                                <div class="d-flex align-items-center justify-content-center py-5">
                                                                                    <b-spinner variant="primary" label="Loading..."></b-spinner>
                                                                                </div>
                                                                            </div>
                                                                            <template v-else>
                                                                                <template v-if="q.files.length == 0">
                                                                                    <div class="d-flex align-items-center justify-content-center py-5">
                                                                                        <div class="text-center">
                                                                                            <i class="bx bx-file font-size-24 mb-2"></i>
                                                                                            <p class="mb-0">No files submitted for this quarter.</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <div class="mb-2">
                                                                                        <input type="text" class="form-control w-auto" placeholder="Search files..." v-model="y.filter">
                                                                                    </div>
                                                                                    <template v-if="filteredFiles(y.filter, q.files).length === 0">
                                                                                        <div class="d-flex align-items-center justify-content-center py-5">
                                                                                            <div class="text-center">
                                                                                                <i class="bx bx-file font-size-24 mb-2"></i>
                                                                                                <p class="mb-0">No files match your search.</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </template>
                                                                                    <template v-else>
                                                                                        <div class="d-flex flex-wrap gap-2">
                                                                                            <div
                                                                                                v-for="(y, index) in filteredFiles(y.filter, q.files)"
                                                                                                :key="y.id"
                                                                                                class="position-relative cursor-pointer border br-5"
                                                                                                :style="`width: 300px; z-index: ${q.files.length - index}`"
                                                                                            >
                                                                                                <div class="border p-3 h-100 d-flex flex-column">
                                                                                                    <div>
                                                                                                        <div class="float-end ms-2">
                                                                                                            <b-dropdown
                                                                                                                right
                                                                                                                variant="link"
                                                                                                                toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                                                                menu-class="dropdown-menu-end"
                                                                                                                no-caret
                                                                                                            >
                                                                                                                <template #button-content>
                                                                                                                    <i class="mdi mdi-dots-horizontal"></i>
                                                                                                                </template>
                                                                                                                <b-dropdown-item @click="openDocument(y)">
                                                                                                                    <i class="bx bx-link-external me-1"></i>Open
                                                                                                                </b-dropdown-item>
                                                                                                                <b-dropdown-item  @click="downloadFile(y.id)">
                                                                                                                    <i class="bx bx-download me-1"></i>Download
                                                                                                                </b-dropdown-item>
                                                                                                            </b-dropdown>
                                                                                                        </div>
                                                                                                        <div class="avatar-xs me-3 mb-2" @click="openDocument(y)">
                                                                                                            <div class="avatar-title bg-transparent rounded">
                                                                                                                <i
                                                                                                                    v-if="y.fileType && y.fileType.includes('image')"
                                                                                                                    class="mdi mdi-image font-size-24 text-purple"
                                                                                                                ></i>
                                                                                                                <i
                                                                                                                    v-if="y.fileType && y.fileType.includes('application')"
                                                                                                                    class="mdi mdi-file-pdf-outline font-size-24 text-danger"
                                                                                                                ></i>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div class="d-flex" @click="openDocument(y)">
                                                                                                            <div class="overflow-hidden me-auto">
                                                                                                                <h5 class="font-size-14 text-truncate mb-1 hover-underline">{{ y.description }}</h5>
                                                                                                                <p class="text-muted mb-0">
                                                                                                                    {{ formatDateWithTime(new Date(y.dateTimeUploaded)) }}
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </template>
                                                                                </template>
                                                                            </template>
                                                                        </b-tab>
                                                                    </b-tabs>
                                                                </b-card-body>
                                                            </b-collapse>
                                                        </b-card>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </template>
                                </template>
                                <div class="row mt-3">
                                    <div class="col">
                                        <div
                                            class="
                                                dataTables_paginate
                                                paging_simple_numbers
                                                float-end
                                            "
                                        >
                                            <ul class="pagination pagination-rounded mb-0">
                                                <b-pagination
                                                    v-model="currentPage"
                                                    :total-rows="rows(x)"
                                                    :per-page="perPage"
                                                ></b-pagination>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </template>
        <AttachmentModal
            :wActions="true"
            title="Accomplishment Report Templates"
            ref="attachmentModal"
        ></AttachmentModal>
    </Layout>
</template>